module.exports = __webpack_public_path__ + "img/social-step-4.40dd91a1.svg";